import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n";
import { OrderProvider } from "@/components/OrderDialog";
import { CartProvider } from "@/components/Cart";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { MobileCTA } from "@/components/MobileCTA";
import Home from "@/pages/Home";
import MenuPage from "@/pages/MenuPage";
import { DeliveryNotice } from "@/components/DeliveryNotice";

const ScrollManager = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.__lenis?.scrollTo(0, { immediate: true });
    }, [pathname]);
    return null;
};

function App() {
    useEffect(() => {
        // Lenis momentum scroll only on precise-pointer devices (desktop);
        // mobile keeps native scrolling for zero-JS-cost touch performance
        const finePointer = window.matchMedia("(pointer: fine)").matches;
        let lenis;
        let rafId;
        if (finePointer) {
            lenis = new Lenis({ duration: 1.1, smoothWheel: true });
            window.__lenis = lenis;
            const raf = (time) => {
                lenis.raf(time);
                rafId = requestAnimationFrame(raf);
            };
            rafId = requestAnimationFrame(raf);
        }
        document.body.classList.add("grain");
        return () => {
            if (rafId) cancelAnimationFrame(rafId);
            if (lenis) lenis.destroy();
        };
    }, []);

    return (
        <div className="App bg-ink text-cream">
            <BrowserRouter>
                <LanguageProvider>
                <OrderProvider>
                    <CartProvider>
                        <ScrollManager />
                        <Navbar />
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/menu" element={<MenuPage />} />
                        </Routes>
                        <Footer />
                        <MobileCTA />
                        <Toaster position="top-center" theme="dark" />
                        <DeliveryNotice />
                    </CartProvider>
                </OrderProvider>
                </LanguageProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
